"use strict";
var async_1 = require('../../facade/async');
var lang_1 = require('../../facade/lang');
var instruction_1 = require('../../instruction');
var SyncRouteHandler = (function () {
    function SyncRouteHandler(componentType, data) {
        this.componentType = componentType;
        /** @internal */
        this._resolvedComponent = null;
        this._resolvedComponent = async_1.PromiseWrapper.resolve(componentType);
        this.data = lang_1.isPresent(data) ? new instruction_1.RouteData(data) : instruction_1.BLANK_ROUTE_DATA;
    }
    SyncRouteHandler.prototype.resolveComponentType = function () { return this._resolvedComponent; };
    return SyncRouteHandler;
}());
exports.SyncRouteHandler = SyncRouteHandler;
//# sourceMappingURL=sync_route_handler.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/@angular/router-deprecated/src/rules/route_handlers/sync_route_handler.js
 ** module id = 461
 ** module chunks = 0
 **/